import {useRouteMatch} from "react-router-dom";
import {useState} from "react";
import {Tab, Tabs, Typography} from "@mui/material";
import {TitleAppBar} from "~/ui/AppBar/TitleAppBar";
import {AbsoluteContainer} from "~/apps/core/ui/AbsoluteContainer";
import {LoadingBox} from "~/apps/core/ui/LoadingBox";
import SwipeableViews from "react-swipeable-views";
import {Box} from "@mui/system";
import {useCargoDetail} from "~/apps/packages/cargos/hooks";
import {CargoDetailInfo} from "~/apps/packages/cargos/components/CargoDetail/CargoDetailInfo";
import {CargoDetailHistory} from "~/apps/packages/cargos/components/CargoDetail/CargoDetailHistory";


export const DetailPage = (props) => {
    const match = useRouteMatch<{id: string}>();
    const {loading, data} = useCargoDetail(match.params.id);
    const [currentTab, setCurrentTab] = useState<number>(0);
    const appBarHeight = 104;

    const handleTabChange = (_, value) => {
        setCurrentTab(value);
    }

    const handleSwipeableViewIndexChange = (value) => {
        setCurrentTab(value);
    }

    return (
        <>
            <TitleAppBar title="Груз"/>
            <AbsoluteContainer top={56} disableGutters>
                <LoadingBox loading={loading}>
                    <Box paddingX="16px">
                        {data && <CargoDetailInfo cargo={data}/>}
                        {data && (
                            <Typography variant="screenText" color="primary">
                                История груза
                            </Typography>
                        )}
                        {data && <CargoDetailHistory cargo={data}/>}
                    </Box>
                </LoadingBox>
            </AbsoluteContainer>
        </>
    );

    // return (
    //     <>
    //         <TitleAppBar title="Груз">
    //             <Tabs value={currentTab} onChange={handleTabChange}>
    //                 <Tab label="Информация"/>
    //                 <Tab label="История"/>
    //             </Tabs>
    //         </TitleAppBar>
    //         <AbsoluteContainer top={appBarHeight} disableGutters>
    //             <LoadingBox loading={loading}>
    //                 {!loading && /*при вычислении высоты во время загрузки, после отображается неверно*/ (
    //                     <SwipeableViews
    //                         index={currentTab}
    //                         onChangeIndex={handleSwipeableViewIndexChange}
    //                         enableMouseEvents={true}
    //                         animateHeight={true}
    //                     >
    //                         <Box height={window.innerHeight - appBarHeight} paddingX={2}  overflow="auto">
    //                             <CargoDetailInfo cargo={data}/>
    //                         </Box>
    //                         <Box height={window.innerHeight - appBarHeight} paddingX={2}  overflow="auto">
    //                             <CargoDetailHistory cargo={data}/>
    //                         </Box>
    //                     </SwipeableViews>
    //                 )}
    //             </LoadingBox>
    //         </AbsoluteContainer>
    //     </>
    // )
}